import { render, staticRenderFns } from "./UzimaUg.vue?vue&type=template&id=beacaea4&"
import script from "./UzimaUg.vue?vue&type=script&lang=js&"
export * from "./UzimaUg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports